"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = void 0 && (void 0).__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = void 0 && (void 0).__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var spaui_1 = require("@tencent/spaui");
var classnames_1 = __importDefault(require("classnames"));
var MetaTabsButtonGroup = function MetaTabsButtonGroup(props) {
  if (props === void 0) {
    props = {};
  }
  var className = props.className,
    data = props.data,
    value = props.value,
    onChange = props.onChange,
    disabled = props.disabled,
    multiple = props.multiple,
    children = props.children,
    foldButtonHottag = props.foldButtonHottag,
    _a = props.show,
    show = _a === void 0 ? false : _a,
    _b = props.foldData,
    foldData = _b === void 0 ? [] : _b;
  var defaultShowData = data.filter(function (item) {
    return !foldData.includes(item.value);
  });
  var valueIndex = defaultShowData.indexOf(value);
  var _c = __read((0, react_1.useState)(defaultShowData.length > 0 && valueIndex > -1), 2),
    isFold = _c[0],
    setFoldStatus = _c[1];
  var handleFoldChange = (0, react_1.useCallback)(function () {
    setFoldStatus(!isFold);
  }, [isFold]);
  if (!show) {
    return null;
  }
  var showData = [];
  var showFoldButton = defaultShowData.length > 0 && foldData.length > 0;
  if (isFold && showFoldButton) {
    showData = __spreadArray([], __read(defaultShowData), false);
    // 如果收起后，跟需要显示的还是一样数量的话，就不展示收起展开了
    if (showData.length === data.length) {
      showFoldButton = false;
    }
  } else {
    showData = data;
  }
  if (showFoldButton) {
    return react_1["default"].createElement("div", {
      className: "inline-flex gap-6 button-group-box"
    }, react_1["default"].createElement(spaui_1.ButtonGroup, {
      className: className,
      data: showData,
      value: value,
      onChange: onChange,
      disabled: disabled,
      multiple: multiple
    }, children), showFoldButton ? react_1["default"].createElement(spaui_1.Button, {
      className: (0, classnames_1["default"])('button-unfold', {
        fold: showData.length >= data.length
      }),
      onClick: handleFoldChange,
      "data-hottag": foldButtonHottag,
      "data-hottag-content": "".concat(showData.length >= data.length ? 'fold' : 'unfold')
    }, react_1["default"].createElement(spaui_1.Icon, {
      name: "right-arrow-double-outlined"
    })) : null);
  }
  return react_1["default"].createElement(spaui_1.ButtonGroup, {
    className: className,
    data: data,
    value: value,
    onChange: onChange,
    disabled: disabled,
    multiple: multiple
  }, children);
};
exports["default"] = (0, react_1.memo)(MetaTabsButtonGroup);